export default "/packs/images/select-arrows~71263901053c13840acf55dabc9accce.jpg";